import camelC from 'lodash/camelCase';
import forOwn from 'lodash/forOwn';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
function handleObject(obj) {
    const newObj = {};
    forOwn(obj, (val, key) => {
        newObj[camelC(key)] = camelCaseKeys(val);
    });
    return newObj;
}
function camelCaseKeys(value) {
    if (isArray(value)) {
        return value.map(camelCaseKeys);
    }
    if (isObject(value)) {
        return handleObject(value);
    }
    return value;
}
export function camelCase(data) {
    if (!(isEmpty(data) || isString(data))) {
        if (isArray(data)) {
            return data.map((obj) => camelCaseKeys(obj));
        }
        return camelCaseKeys(data);
    }
    return data;
}
